<template>
  <div class="leader-level-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="hint">
            团长福利-----根据<strong>邀请人数</strong>以及<strong>团队提现总额（元）</strong>来决定团长等级
          </div>
          <div class="action-group">
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增等级</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && list.length === 0" description="暂无等级配置" />

      <div v-else>
        <el-table
          :data="list"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在加载..."
          row-key="id"
        >
          <el-table-column prop="id" label="ID" width="70" align="center" />
          <el-table-column prop="levelCode" label="等级码" width="90" align="center" />
          <el-table-column prop="levelName" label="等级名称" min-width="120" />
          <el-table-column prop="minDirectCount" label="直推人数≥" width="110" align="center" />
          <el-table-column prop="minTeamWithdraw" label="团队提现≥(元)" min-width="140" align="center">
            <template slot-scope="scope">
              {{ scope.row.minTeamWithdraw }}
            </template>
          </el-table-column>
          <el-table-column prop="directRate" label="直推比例%" width="100" align="center" />
          <el-table-column prop="indirectRate" label="间推比例%" width="100" align="center" />
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success" size="small">启用</el-tag>
              <el-tag v-else type="info" size="small">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button
                type="text"
                size="small"
                class="danger-text"
                :disabled="scope.row.levelCode === 0"
                @click="handleDelete(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="isEdit ? '编辑等级' : '新增等级'"
      :visible.sync="dialogVisible"
      width="520px"
      append-to-body
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="等级码" prop="levelCode">
          <el-input-number
            v-model="form.levelCode"
            :min="0"
            :disabled="isEdit && form.levelCode === 0"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="等级名称" prop="levelName">
          <el-input v-model.trim="form.levelName" maxlength="50" placeholder="如：青铜团长" />
        </el-form-item>
        <el-form-item label="直推人数≥" prop="minDirectCount">
          <el-input-number v-model="form.minDirectCount" :min="0" controls-position="right" />
        </el-form-item>
        <el-form-item label="团队提现≥(元)" prop="minTeamWithdraw">
          <el-input-number v-model="form.minTeamWithdraw" :min="0" :step="1" controls-position="right" />
          <div class="form-tip">直推+间推两层实际到账提现累计，单位：元</div>
        </el-form-item>
        <el-form-item label="直推比例%" prop="directRate">
          <el-input-number v-model="form.directRate" :min="0" :max="9999" controls-position="right" />
        </el-form-item>
        <el-form-item label="间推比例%" prop="indirectRate">
          <el-input-number v-model="form.indirectRate" :min="0" :max="9999" controls-position="right" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del, getResponseMessage } from '@/utils/http.js'

export default {
  name: 'LeaderLevelManagement',
  data() {
    return {
      loading: false,
      submitting: false,
      error: '',
      list: [],
      pagination: { page: 1, pageSize: 20, total: 0 },
      dialogVisible: false,
      isEdit: false,
      editId: null,
      form: this.emptyForm(),
      rules: {
        levelCode: [{ required: true, message: '请输入等级码', trigger: 'blur' }],
        levelName: [{ required: true, message: '请输入等级名称', trigger: 'blur' }],
        minDirectCount: [{ required: true, message: '请输入直推门槛', trigger: 'blur' }],
        minTeamWithdraw: [{ required: true, message: '请输入团队提现门槛', trigger: 'blur' }],
        directRate: [{ required: true, message: '请输入直推比例', trigger: 'blur' }],
        indirectRate: [{ required: true, message: '请输入间推比例', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    emptyForm() {
      return {
        levelCode: 1,
        levelName: '',
        minDirectCount: 0,
        minTeamWithdraw: 0,
        directRate: 5,
        indirectRate: 3,
        status: 1
      }
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const res = await get('/admin/leader-level/page', {
          pageNum: this.pagination.page,
          pageSize: this.pagination.pageSize
        })
        const data = res.data || {}
        this.list = data.records || []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.list = []
        this.error = e.message || '加载失败'
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.isEdit = false
      this.editId = null
      this.form = this.emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.form = {
        levelCode: row.levelCode,
        levelName: row.levelName,
        minDirectCount: row.minDirectCount,
        minTeamWithdraw: row.minTeamWithdraw,
        directRate: row.directRate,
        indirectRate: row.indirectRate,
        status: row.status == null ? 1 : row.status
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.isEdit) {
            await put(`/admin/leader-level/${this.editId}`, this.form)
            this.$message.success('更新成功')
          } else {
            await post('/admin/leader-level', this.form)
            this.$message.success('创建成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(getResponseMessage(e) || e.message || '保存失败')
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确定删除等级「${row.levelName}」吗？`, '提示', { type: 'warning' })
        .then(async () => {
          try {
            await del(`/admin/leader-level/${row.id}`)
            this.$message.success('已删除')
            this.fetchList()
          } catch (e) {
            this.$message.error(getResponseMessage(e) || e.message || '删除失败')
          }
        })
        .catch(() => {})
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}
.hint {
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
  flex: 1;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
.error {
  color: #f56c6c;
  margin-bottom: 12px;
}
.danger-text {
  color: #f56c6c;
}
.form-tip {
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 4px;
}
</style>
